import { usePopup } from "react-hook-popup";
import SimplePopupDialog from "../components/SimplePopupDialog";

function useSFSuccess(callback) {
  return usePopup("success", ({ handleClose }) => {
    return (
      <SimplePopupDialog
        title="Success"
        message="Complete"
        handleClose={() => {
          handleClose();
          if (callback) callback(); // can't use window reload
        }}
      />
    );
  });
}

export default useSFSuccess;
